import { CompanyDetailsFormWebComponent } from './component/CompanyDetailsFormWebComponent';
import { WEB_COMPONENT_COMPANY_DETAILS_FORM } from '../../../webcomponents.constants';

export { CompanyDetailsFormWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANY_DETAILS_FORM, CompanyDetailsFormWebComponent);
